import React, { useEffect, useState } from "react";
import "../css/FloatingSidebar.css";

import libel from "../images/logo_dot.png"
import { useSelector } from "react-redux";

import {
    IoClose,
    IoWalletOutline,
} from "react-icons/io5";


import {
    AiOutlineHome,
    AiOutlineQuestionCircle,
    AiOutlineUnorderedList,
    AiOutlineDollar,
} from "react-icons/ai";

const links = [
    {
        id: 1,
        title: "Inicio",
        Icon: AiOutlineHome,
        url: "#home",
        location: 0,
    },
    {
        id: 2,
        title: "¿Qué Aprenderás?",
        Icon: AiOutlineUnorderedList,
        url: "#learn",
        location: 936,
    },
    // {
    //     id: 3,
    //     title: "Método de Estudio",
    //     Icon: AiOutlineStock,
    //     url: "#study",
    //     location: 936,
    // },
    {
        id: 4,
        title: "Inversión",
        Icon: AiOutlineDollar,
        url: "#entrenamientos",
        location: 936,
    },
    {
        id: 5,
        title: "Métodos de Pago",
        Icon: IoWalletOutline,
        url: "#metodos-de-pago",
        location: 3186,
    },
    {
        id: 6,
        title: "Preguntas",
        Icon: AiOutlineQuestionCircle,
        url: "#faq",
        location: 3706,
    },
];

const FloatingSidebar = () => {

    const sideMenu = useSelector((state) => state.sideMenu.value.menu);

    const [expanded, setExpanded] = useState(true);
    const [appear, setAppear] = useState({ opacity: 0 });

    const handleLink = (e) => {
        e.preventDefault();
        const target = e.target.getAttribute("href");
        const location = document.querySelector(target).offsetTop;
        window.scrollTo({
            left: 0,
            top: location - 80,
        });
    };

    useEffect(() => {
        if (expanded) {
            setTimeout(() => {
                setAppear({ opacity: 1 });
            }, 300);
        } else {
            setAppear({ opacity: 0 });
        }
    }, [expanded]);

    return (
        <div
            className={
                expanded ? "FloatingSidebar expanded" : "FloatingSidebar"
            }
            style={
                sideMenu
                    ? {
                          transform: "translateX(-200%)",
                          visibility: "hidden",
                          opacity: 0,
                      }
                    : {
                          transform: "translateX(0)",
                          visibility: "visible",
                          opacity: 1,
                      }
            }
        >
            <div
                className={
                    expanded ? "sidebar-icon-close" : "sidebar-icon-open"
                }
                onClick={() => {
                    setExpanded(!expanded);
                }}
            >
                {expanded ? (
                    <IoClose />
                ) : (
                    <img src={libel} alt="Libel Academy" />
                )}
            </div>
            {expanded ? (
                <div className="sidebar-links" style={appear}>
                    {links.map(({ id, title, url, Icon }) => (
                        <span key={id}>
                            <Icon />{" "}
                            <a href={url} onClick={handleLink}>
                                {title}
                            </a>
                        </span>
                    ))}
                </div>
            ) : null}
        </div>
    );
};

export default FloatingSidebar;
